export const ru = {
    'button-cancel': 'Отмена',
    'button-submit': 'Применить',
    'highest-bid': 'Обратите внимание — остановлена слишком высокая ставка'
};
